// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VFha2N {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 16px);
  width: 100%;
  box-sizing: border-box;
}

.d1GqCC {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
  width: 100%;
}

.YvKtQ9 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1, 8px);
  width: 100%;
}

.wEIKKv {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.wEIKKv:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.p94f5n {
  flex-shrink: 0;
  cursor: pointer;
  transition: opacity 0.2s;
}

.p94f5n:hover {
  opacity: 0.7;
}

.TBaENk {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-xl, 24px);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  padding: 0;
}

.qi8emx {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 140%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  padding: 0;
}

.Seexp_ {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: var(--spacing-2, 16px);
}

.Hwm5at {
  display: flex;
  gap: var(--spacing-1, 8px);
  justify-content: center;
  align-items: center;
  width: 100%;
}

.jSufwV {
  width: 48px;
  height: 57px;
  text-align: center;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-lg, 20px);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark, #1f1f1f);
  background: var(--surface-neutral-softer, #fafafa);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
  border-radius: var(--radius-s, 4px);
  outline: none;
  box-sizing: border-box;
}

.jSufwV:focus {
  border-color: var(--surface-primary-medium, #d64000);
  background: var(--surface-neutral-white, #ffffff);
}

.jSufwV:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

._ECPIG {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-sm, 12px);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--status-error, #dc0a0a);
  margin: var(--spacing-1, 8px) 0 0 0;
  padding: 0;
  text-align: center;
}

.wRyUOW {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--text-neutral-dark, #1f1f1f);
  margin: 0;
  padding: 0;
  text-align: center;
}

.S0hpcf {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 14px);
  line-height: 100%;
  letter-spacing: 0px;
  color: var(--link-default, #0066cc);
  text-decoration: underline;
  margin: 0;
  transition: opacity 0.2s;
  vertical-align: middle;
}

.S0hpcf:hover:not(:disabled) {
  opacity: 0.8;
}

.S0hpcf:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dmOFZu {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5, 12px);
  width: 100%;
  margin-top: var(--spacing-2, 16px);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/components/ResetPassword/components/TokenValidation/TokenValidation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kDAAkD;EAClD,uDAAuD;EACvD,mCAAmC;EACnC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,0BAA0B;EAC1B,SAAS;EACT,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,kCAAkC;AACpC","sourcesContent":[".tokenValidationWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 16px);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.tokenValidationHeader {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n  width: 100%;\n}\n\n.tokenValidationTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1, 8px);\n  width: 100%;\n}\n\n.tokenValidationBackButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.tokenValidationBackButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tokenValidationBackIcon {\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.tokenValidationBackIcon:hover {\n  opacity: 0.7;\n}\n\n.tokenValidationTitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-xl, 24px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  padding: 0;\n}\n\n.tokenValidationSubtitle {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 140%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  padding: 0;\n}\n\n.tokenValidationPinContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: var(--spacing-2, 16px);\n}\n\n.tokenValidationPinInputs {\n  display: flex;\n  gap: var(--spacing-1, 8px);\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.tokenValidationPinInput {\n  width: 48px;\n  height: 57px;\n  text-align: center;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-lg, 20px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  background: var(--surface-neutral-softer, #fafafa);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n  border-radius: var(--radius-s, 4px);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.tokenValidationPinInput:focus {\n  border-color: var(--surface-primary-medium, #d64000);\n  background: var(--surface-neutral-white, #ffffff);\n}\n\n.tokenValidationPinInput:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tokenValidationError {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-sm, 12px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--status-error, #dc0a0a);\n  margin: var(--spacing-1, 8px) 0 0 0;\n  padding: 0;\n  text-align: center;\n}\n\n.tokenValidationWaitText {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--text-neutral-dark, #1f1f1f);\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n\n.tokenValidationResendLink {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 14px);\n  line-height: 100%;\n  letter-spacing: 0px;\n  color: var(--link-default, #0066cc);\n  text-decoration: underline;\n  margin: 0;\n  transition: opacity 0.2s;\n  vertical-align: middle;\n}\n\n.tokenValidationResendLink:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.tokenValidationResendLink:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.tokenValidationActions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5, 12px);\n  width: 100%;\n  margin-top: var(--spacing-2, 16px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tokenValidationWrapper": `VFha2N`,
	"tokenValidationHeader": `d1GqCC`,
	"tokenValidationTitleContainer": `YvKtQ9`,
	"tokenValidationBackButton": `wEIKKv`,
	"tokenValidationBackIcon": `p94f5n`,
	"tokenValidationTitle": `TBaENk`,
	"tokenValidationSubtitle": `qi8emx`,
	"tokenValidationPinContainer": `Seexp_`,
	"tokenValidationPinInputs": `Hwm5at`,
	"tokenValidationPinInput": `jSufwV`,
	"tokenValidationError": `_ECPIG`,
	"tokenValidationWaitText": `wRyUOW`,
	"tokenValidationResendLink": `S0hpcf`,
	"tokenValidationActions": `dmOFZu`
};
module.exports = ___CSS_LOADER_EXPORT___;
